import { render } from "./CorporateDetail.vue?vue&type=template&id=c8b317ac"
import script from "./CorporateDetail.vue?vue&type=script&lang=js"
export * from "./CorporateDetail.vue?vue&type=script&lang=js"

import "./CorporateDetail.vue?vue&type=style&index=0&id=c8b317ac&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__